import { Link } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";

function LegalPage({ title, titleAccent, lead, sections }) {
  return (
    <main className="legal">
      <div className="container container--narrow">
        <Breadcrumb current={title} />
        <header className="legal__header">
          <h1 className="legal__title">
            <span className="gradient-text">{title}</span>{" "}
            <span className="legal__title-accent">{titleAccent}</span>
          </h1>
          <p className="legal__lead">{lead}</p>
        </header>

        <hr className="legal__divider" />

        {sections.map((section) => (
          <section className="legal__section" key={section.heading}>
            <h2 className="legal__heading">{section.heading}</h2>
            {section.body && <p className="legal__body">{section.body}</p>}
            {section.link && (
              <Link className="legal__link" to={section.link.href}>
                {section.link.label}
              </Link>
            )}
            {section.list && (
              <ul className="legal__list">
                {section.list.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
    </main>
  );
}

export default LegalPage;
